import SettingsPage from "./settings";

export default SettingsPage;